import _ from "lodash";

export const AvatarUploadHook = {
  mounted() {
    renderInput(this.el, this);
  },

  updated() {
    renderInput(this.el, this);
  },
};

function renderInput(el) {
  handleDropAreaHover(el.querySelector(".avatar-drop-area"), "bg-default-bg-hover");
  handleDropAreaHover(el.querySelector("img"), "opacity-50");
  handleButtonClick(el.querySelector(".upload-avatar-btn"), el.querySelector('input[type="file"]'));
}

function handleDropAreaHover(dropArea, hoverClass) {
  if (dropArea) {
    for (const eventName of ["dragenter", "dragover"]) {
      dropArea.addEventListener(eventName, () => {
        dropArea.classList.add(hoverClass);
      });
    }

    for (const eventName of ["dragleave", "drop"]) {
      dropArea.addEventListener(eventName, () => {
        dropArea.classList.remove(hoverClass);
      });
    }
  }
}

function handleButtonClick(button, fileInput) {
  const triggerUpload = () => {
    fileInput.click();
  };
  button.addEventListener(
    "click",
    _.debounce(triggerUpload, 1000, { leading: true, trailing: false }),
  );
}
